import { FC } from 'react'
import classes from './pageCard.module.scss'

interface SentimentBarProps {
  negative: number
  neutral: number
  positive: number
}

const SEGMENTS = [
  { key: 'positive', label: 'Positive' },
  { key: 'neutral', label: 'Neutral' },
  { key: 'negative', label: 'Negative' },
] as const

// Stacked positive / neutral / negative bar with the counts underneath.
// Segments keep a 2px minimum so a 1% bucket is still visible; the legend
// is space-between (not positioned under each segment) so tiny buckets can't
// make the labels collide.
export const SentimentBar: FC<SentimentBarProps> = (counts) => {
  const total = counts.positive + counts.neutral + counts.negative
  const percent = (value: number) => (total ? (value / total) * 100 : 0)

  return (
    <div className={classes.sentimentBar}>
      <div
        aria-label={SEGMENTS.map(
          ({ key, label }) => `${label} ${Math.round(percent(counts[key]))}%`
        ).join(', ')}
        className={classes.sentimentTrack}
        role="img"
      >
        {total > 0 &&
          SEGMENTS.map(({ key }) =>
            counts[key] > 0 ? (
              <span
                className={`${classes.sentimentSegment} ${classes[key]}`}
                key={key}
                style={{ flexGrow: counts[key] }}
              />
            ) : null
          )}
      </div>
      <div className={classes.sentimentLegend}>
        {SEGMENTS.map(({ key, label }) => (
          <span className={classes.sentimentLegendItem} key={key}>
            <span className={`${classes.legendDot} ${classes[key]}`} />
            <strong>{counts[key].toLocaleString()}</strong> {label}
          </span>
        ))}
      </div>
    </div>
  )
}
